/**
 * WordPress dependencies
 */
import warning from '@wordpress/warning';
export default warning;
